import { useIsAuthenticated } from '@heidi/auth/state';
import { type components } from '@heidi/schema/ml-scribe';
import { skipToken, useQuery } from '@tanstack/react-query';

import { GET_TEAM_ACCESS_ENTITLEMENTS } from '../../contracts/keys';
import { getTeamAccessEntitlements } from '../api/entitlements';
import { getWorkspaceDataConfig } from '../config';

export type TeamLevelAccessEntitlementsResponse =
  components['schemas']['TeamLevelAccessEntitlementsResponse'];

/**
 * GET /api/v2/ml-scribe/access-entitlements/team/{team_id}
 * List effective access entitlements for the team (team + org merge). Caller must be a team admin.
 */
export function useQueryTeamAccessEntitlements(teamId: string | undefined) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQuery({
    queryKey: [GET_TEAM_ACCESS_ENTITLEMENTS, teamId],
    enabled: isAuthenticated && !!teamId,
    queryFn:
      isAuthenticated && teamId
        ? async () => {
            const { data } = await getTeamAccessEntitlements(teamId);
            return data;
          }
        : skipToken,
  });
}

export async function invalidateTeamAccessEntitlements(teamId: string) {
  await getWorkspaceDataConfig().queryClient.invalidateQueries({
    queryKey: [GET_TEAM_ACCESS_ENTITLEMENTS, teamId],
  });
}
